import { useEffect } from "react";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ManageAccountTabs from "./Tabs";
import { getLevel } from "../../store/middleware";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";
import Myaccount from "../../assets/images/icons/icon_myaccount_header.svg";

import { LevelScoreAccountStyles } from "./Styles";

function LevelScoreAccount() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);
  const { levels } = useSelector((state) => state.genericReducer);

  const callApi = () => dispatch(getLevel(user.id));

  useEffect(() => {
    if (user.id > 0) callApi();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          t={t}
          typeIcon="custom"
          title={t("MANAGE_ACCOUNT_TITLE")}
          icon={<img src={Myaccount} alt={t("MANAGE_ACCOUNT_TITLE")} />}
        />

        <LevelScoreAccountStyles>
          <div className="tabs">
            <ManageAccountTabs />

            {plans?.length > 1 ? (
              plans?.map((plan) => (
                <div className="tab-content" key={plan?.planId}>
                  {plan.planId !== 4 && levels?.length > 0 && (
                    <div className="box">
                      {levels
                        ?.filter(
                          (level) => level?.lingoLanguage?.id === plan.studentPlanLanguages[0]?.lingoLanguage?.id,
                        )
                        .map((level, index) => {
                          return (
                            <div key={index} className="boxBig">
                              <div className="itemBox">
                                <div className="levelTop">
                                  <div className="levelTopLinguage">
                                    <div className="boxLanguage">
                                      <h5>LINGO</h5>
                                      <div className="language">
                                        <FlagIcon size={35} code={level?.lingoLanguage?.flag} />
                                        <h5>{t(level?.lingoLanguage?.description.toUpperCase())}</h5>
                                      </div>
                                    </div>
                                    <div className="columLevel">
                                      <div>
                                        <h5>{t("CARD_PLAN_LEVEL")}</h5>
                                        <h5>{level.level.level}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="levelContent">
                                  <div className="grades">
                                    <h6>{t("GRADES")}</h6>
                                    <div>
                                      <h5>
                                        <span>{t("ORAL")}</span>
                                      </h5>
                                      <h5>{level.oralGrade}</h5>
                                    </div>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("WRITING")}</span>
                                    </h5>
                                    <h5>{level.writingGrade}</h5>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("DICTATION")}</span>
                                    </h5>
                                    <h5>{level.dictationGrade}</h5>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("AVERAGE")}</span>
                                    </h5>
                                    <h5>{level.averageGrade}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="tab-content">
                {plans?.length && plans[0]?.planId !== 4 && levels?.length > 0 && (
                  <div className="box">
                    {levels?.map((level, index) => {
                      return (
                        <div key={index} className="boxBig">
                          <div className="itemBox">
                            <div className="levelTop">
                              <div className="levelTopLinguage">
                                <div className="boxLanguage">
                                  <h5>LINGO</h5>
                                  <div className="language">
                                    <FlagIcon size={35} code={level?.lingoLanguage?.flag} />
                                    <h5>{t(level?.lingoLanguage?.description.toUpperCase())}</h5>
                                  </div>
                                </div>
                                <div className="columLevel">
                                  <div>
                                    <h5>{t("CARD_PLAN_LEVEL")}</h5>
                                    <h5>{level.level.level}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="levelContent">
                              <div className="grades">
                                <h6>{t("GRADES")}</h6>
                                <div>
                                  <h5>
                                    <span>{t("ORAL")}</span>
                                  </h5>
                                  <h5>{level.oralGrade}</h5>
                                </div>
                              </div>
                              <div className="another-grades">
                                <h5>
                                  <span>{t("WRITING")}</span>
                                </h5>
                                <h5>{level.writingGrade}</h5>
                              </div>
                              <div className="another-grades">
                                <h5>
                                  <span>{t("DICTATION")}</span>
                                </h5>
                                <h5>{level.dictationGrade}</h5>
                              </div>
                              <div className="another-grades">
                                <h5>
                                  <span>{t("AVERAGE")}</span>
                                </h5>
                                <h5>{level.averageGrade}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {plans
                  ?.filter((plan) => plan.planId === 4)
                  ?.map(() =>
                    levels
                      .slice()
                      .sort((a, b) => a?.lingoLanguageId - b?.lingoLanguageId)
                      .map((level, index) => {
                        return (
                          <div className="box" key={index}>
                            <div key={index} className="boxBig">
                              <div className="itemBox">
                                <div className="levelTop">
                                  <div className="levelTopLinguage">
                                    <div className="boxLanguage">
                                      <h5>LINGO</h5>
                                      <div className="language">
                                        <FlagIcon size={35} code={level?.lingoLanguage?.flag} />
                                        <h5>{t(level?.lingoLanguage?.description.toUpperCase())}</h5>
                                      </div>
                                    </div>
                                    <div className="columLevel">
                                      <div>
                                        <h5>{t("CARD_PLAN_LEVEL")}</h5>
                                        <h5>{level.level.level}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="levelContent">
                                  <div className="grades">
                                    <h6>{t("GRADES")}</h6>
                                    <div>
                                      <h5>
                                        <span>{t("ORAL")}</span>
                                      </h5>
                                      <h5>{level.oralGrade}</h5>
                                    </div>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("WRITING")}</span>
                                    </h5>
                                    <h5>{level.writingGrade}</h5>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("DICTATION")}</span>
                                    </h5>
                                    <h5>{level.dictationGrade}</h5>
                                  </div>
                                  <div className="another-grades">
                                    <h5>
                                      <span>{t("AVERAGE")}</span>
                                    </h5>
                                    <h5>{level.averageGrade}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }),
                  )}
              </div>
            )}

            {levels?.length === 0 && <PlaceholderText label={t("NO_RESULTS")} />}
          </div>
        </LevelScoreAccountStyles>
      </section>
    </div>
  );
}

export default LevelScoreAccount;
